export enum DocumentViewerAssetType {
  BLOWER = 'blower',
  VALVE = 'valve',
  VESSEL = 'vessel',
  BREAKER = 'breaker',
  COMPRESSOR = 'compressor',
  COOLER = 'cooler',
  DETECTOR = 'detector',
  ELEMENT = 'element',
  FAN = 'fan',
  FILTER = 'filter',
  HEATER = 'heater',
  INSTRUMENT = 'instrument',
  MOTOR = 'motor',
  PUMP = 'pump',
  SOLENOID = 'solenoid',
  STRAINER = 'strainer',
  TANK = 'tank',
  TRANSFORMER = 'transformer',
  TRANSMITTER = 'transmitter',
  ALL = 'all',
  SET_UNKNOWN = 'set-unknown',
  OFF_PAGE_CONNECTOR = 'off_page_connector',
}

export type NormalizedBBox = {
  left: number
  top: number
  width: number
  height: number
}

export type BoundingBoxJsonItem = {
  id: number | string
  bounding_box: NormalizedBBox
  text?: string
  type?: DocumentViewerAssetType
  linkedUnitId?: string
  groupId?: string
  linkedDocumentIds?: string[]
  assetId?: string
}

export const FORCE_HIDE_DOCUMENT_BOXES = true

export function shouldForceHideDocumentBoxes(
  showDocumentOcrBoxes: boolean
): boolean {
  return FORCE_HIDE_DOCUMENT_BOXES && !showDocumentOcrBoxes
}

export type DocumentOcrPage = {
  page_number: number
  /** @deprecated Legacy field — prod data may still use camelCase. Use `page_number` instead. Once all prod OCR entries have been re-ingested with snake_case, remove this field and `normalizeOcrPages`. */
  pageNumber?: number
  confirmed: BoundingBoxJsonItem[]
  unconfirmed: BoundingBoxJsonItem[]
  groups?: { id: string; boxes: BoundingBoxJsonItem[] }[]
}

export function normalizeOcrPages(pages: DocumentOcrPage[]): DocumentOcrPage[] {
  return pages.map((p) => ({
    ...p,
    page_number: p.page_number ?? p.pageNumber ?? 0,
  }))
}

export type DocumentOcrJSON = {
  pages: DocumentOcrPage[]
}
